<script setup>
import { HatGlasses, Undo2 } from 'lucide-vue-next'

defineProps({
    accountName: {
        type: String,
        required: true,
    },
    isExpanded: {
        type: Boolean,
        default: false,
    },
})

const emit = defineEmits(['return'])
</script>

<template>
    <div class="absolute top-8 flex w-24 items-center justify-center">
        <div
            class="relative z-20 flex size-10 items-center justify-center rounded-full bg-pink-500 ring-4 ring-white"
            :title="`Impersonating: ${accountName}`"
        >
            <HatGlasses class="size-4 text-white" aria-hidden="true" />
        </div>
        <span
            :class="{
                'pointer-events-none -translate-x-3 opacity-0 duration-200': !isExpanded,
                'pointer-events-auto opacity-100 duration-500': isExpanded,
            }"
            class="absolute top-0 bottom-0 left-24 -ml-12 flex h-10 w-64 cursor-default items-center rounded-r-full bg-pink-700 pl-10 text-[12px] leading-none text-white transition-all ease-out"
        >
            <span class="flex w-full items-center justify-between pr-1">
                <span class="flex flex-col items-start justify-center">
                    <span class="mb-1 block text-[7px] font-normal">Impersonating</span>
                    <span class="font-medium">{{ accountName }}</span>
                </span>
                <Button
                    v-if="isExpanded"
                    size="md"
                    variant="filled"
                    label="Return to account"
                    color="pink"
                    class="size-8! rounded-full!"
                    @click="emit('return')"
                >
                    <template #icon><Undo2 /></template>
                </Button>
            </span>
        </span>
    </div>
</template>
